import React, { useState } from "react";
import ButtonSecondary from "../buttons/ButtonSecondary";
import { toast } from "react-toastify";
import { Hourglass } from "react-loader-spinner";
import useBillingApi from "../../hooks/api/useBillingApi";

const ModalDeleteCard = ({ isOpen, onClose, card, onCardDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { deleteCard } = useBillingApi();

  const handleDelete = async () => {
    if (!card || !card.id) {
      toast.error("Card information is missing");
      return;
    }

    setIsDeleting(true);
    try {
      const response = await deleteCard(card.id);
      if (response.status === 200) {
        toast.success(response.data.message || "Card deleted successfully");
        if (onCardDeleted) {
          onCardDeleted();
        }
        onClose();
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error || error?.message || "Error deleting card";
      toast.error(errorMessage);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen || !card) {
    return null;
  }

  const cardDisplayName = card.brand
    ? `${card.brand.charAt(0).toUpperCase() + card.brand.slice(1)} **** ${card.last4}`
    : "this card";

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg mx-6 max-w-[500px]">
        <h2 className="text-h6 text-dark4 mb-4 text-center">
          Are you sure you want to delete this card?
        </h2>
        <p className="text-bodyMR text-dark4 text-center mb-2">
          Card: <span className="font-semibold">{cardDisplayName}</span>
        </p>
        {card.is_default && (
          <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4">
            <p className="text-bodyMR text-dark4 text-center">
              This is your default card. After deletion, you may need to set another card as default.
            </p>
          </div>
        )}
        <p className="text-bodyMR text-dark4 text-center mb-4">
          This action is irreversible.
        </p>

        {isDeleting && (
          <div className="flex flex-row justify-center items-center mt-4 mb-4">
            <Hourglass
              visible={true}
              height="40"
              width="40"
              animationDuration="2"
              ariaLabel="hourglass-loading"
              wrapperStyle={{}}
              wrapperClass=""
              colors={["#FF5400", "#FF5400"]}
            />
          </div>
        )}

        <div className="flex justify-center mt-6 space-x-4">
          <ButtonSecondary
            text={isDeleting ? "Deleting..." : "Delete"}
            customClass="bg-redDark text-white text-bodyMR px-[22px] py-[10px]"
            onClick={handleDelete}
            disabled={isDeleting}
          />
          <ButtonSecondary
            text="Cancel"
            customClass="bg-white text-dark4 text-bodyMR border border-dark4 px-[22px] py-[10px]"
            onClick={handleCancel}
            disabled={isDeleting}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteCard;

